// Settings and continuity repository. The only way the app reads or writes
// these records (CLAUDE.md: persistence only through src/db repositories).

import type { Continuity, Settings, VerifyMark } from '../../data/types';
import { getDb } from '../schema';

export const DEFAULT_SETTINGS: Settings = {
  key: 'app',
  theme: 'system',
  styleId: 'peterock',
  learnMode: 'build',
  haptics: true,
  rediscover: false,
};

export const DEFAULT_CONTINUITY: Continuity = {
  key: 'app',
  lastPath: '/dig',
  tabPaths: {},
  scroll: {},
};

export async function loadSettings(): Promise<Settings> {
  const row = await getDb().settings.get('app');
  return { ...DEFAULT_SETTINGS, ...row };
}

export async function saveSettings(patch: Partial<Omit<Settings, 'key'>>): Promise<void> {
  const db = getDb();
  await db.transaction('rw', db.settings, async () => {
    const current = (await db.settings.get('app')) ?? DEFAULT_SETTINGS;
    await db.settings.put({ ...current, ...patch, key: 'app' });
  });
}

/** Ticks one Verify on MPC item. Reads and writes the map in one transaction, so two quick ticks never lose each other. */
export async function setVerifyMark(id: string, mark: VerifyMark): Promise<void> {
  const db = getDb();
  await db.transaction('rw', db.settings, async () => {
    const current = (await db.settings.get('app')) ?? DEFAULT_SETTINGS;
    await db.settings.put({ ...current, key: 'app', verify: { ...current.verify, [id]: mark } });
  });
}

export async function loadContinuity(): Promise<Continuity> {
  const row = await getDb().continuity.get('app');
  return { ...DEFAULT_CONTINUITY, ...row };
}

export async function saveContinuity(patch: Partial<Omit<Continuity, 'key'>>): Promise<void> {
  const db = getDb();
  await db.transaction('rw', db.continuity, async () => {
    const current = (await db.continuity.get('app')) ?? DEFAULT_CONTINUITY;
    await db.continuity.put({ ...current, ...patch, key: 'app' });
  });
}
